export const toTitleCase = (str:string) =>{
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}

export const camelCaseToWords = (s: string) => {
  const result = s.replace(/([A-Z]+)/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}